/**
 * ScrollingAnimations module
 *
 * @module ScrollAnimation
 * @author EN GARDE (Reinhold Seiss, Caihui Yang)
 * * v1.1 
 * @version 1.0
 */

var EN = EN || {};

EN.ScrollingAnimations = (function ($) {
	'use strict';

	var options = {
		selectors: {
			header: '.en-header--js-animate',
			sponsors: '.en-footer__sponsors-bar',
			sponsorLogos: '.en-footer__sponsors',
			body: 'body',
			calDateSm: '.en-calendar__date-small',
			productionTitle: '.en-mdl-prd-header__title',
			productionButton: '.en-mdl-prd-header__ticket',
			productionPlace: '.en-mdl-prd-header__price-location',
			productionHeaderSticky: '.en-mdl-prd-header__main'
		},
		classes: {
			headerHidden: 'en-header--hidden',
			headerAbsolute: 'en-header--absolute',
			logoAbsolute: 'en-header--logo-absolute',
			calDateSmOffset: 'en-calendar__date-small--offset',
			sponsorsHidden: 'en-footer__sponsors-bar--hidden',
			sponsorLogosIn: 'en-footer__sponsors--animate-in',
			sponsorLogosOut: 'en-footer__sponsors--animate-out',
			stickyHeaderActive: 'en-header-is-sticky',
			isSchedule: 'en-is-schedule',
			isNotScrolledToTop: 'en-is-not-scrolled-to-top',
		},
		breakpoints: {
			md: 720,
			lg: 960,
		},
	};

	/**
	 * Initializes ScrollAnimation module and sets listeners for animations.
	 * @memberof module:ScrollAnimation
	 */
	var init = function () {
		// Cache elements for better performance
		var $document = $(document);
		var $window = $(window);
		var $body = $(options.selectors.body);

		var $header = $(options.selectors.header);
		var $calDateSm = $(options.selectors.calDateSm);
		var $sponsors = $(options.selectors.sponsors);
		var $sponsorLogos = $(options.selectors.sponsorLogos);

		var $productionTitle = $(options.selectors.productionTitle);
		var $productionButton = $(options.selectors.productionButton);
		var $productionPlace = $(options.selectors.productionPlace);

		// Helper functions for retrieving and checking metrics
		var getViewportWidth = function() { return Math.max(document.documentElement.clientWidth, window.innerWidth || 0); };
		var getHeaderHeight = function() { return (getViewportWidth() > options.breakpoints.lg) ? 130 : 100; };
		var isScrolledToBottom = function() { return ($window.height() + $window.scrollTop() > $document.height() - 500); };
		var isScrolledToTop = function() { return ($window.scrollTop() == 0); };
		var isScrolledCloseToTop = function() { return ($window.scrollTop() < 40); };
		var isCursorAtBottom = function() { return (clientY > window.innerHeight - 103); }; // 103 sponsors bar height
		var isCursorAtTop = function() { return (clientY < getHeaderHeight()); };

		// Functions for disabling further animation for respective element (header, logo)
		var positionHeaderAbsolute = function() { $header.addClass(options.classes.headerAbsolute); };
		var positionLogoAbsolute = function() { $header.addClass(options.classes.logoAbsolute); };




		// Initialise variables
		var clientY = 200;
		var timeoutFncId;
		var isSchedulePage = false;

		var lastYOffset = window.pageYOffset;
		var headerHeight = getHeaderHeight();
		var viewportWidth = getViewportWidth();

		var scrolledToBottom = isScrolledToBottom();
		var scrolledToTop = isScrolledToTop();
		var scrolledCloseToTop = isScrolledCloseToTop();
		var cursorAtBottom = isCursorAtBottom();
		var cursorAtTop = isCursorAtTop();
		var scrollingUp = false;
		var scrollingDown = false;
		var scrollEvent = false;
		var mouseMoveEvent = false;
		var waitingForInitialScroll = false;


		// Show debug in console
		var debug = false;
		var verboseDebug = false;





		// Helpers for showing and hiding respective elements (header, sponsors)
		var hideHeader = function() {
			// If we are on a larger device, check if the cursor is currently at the top
			// and don't hide the header if this is the case
			if (debug) console.log('Attempting: hideHeader');

			// Exceptions !important
			if (viewportWidth > options.breakpoints.md && cursorAtTop) return;
			if (lastYOffset < getHeaderHeight()) return;
			if (scrolledToTop) return;
			if (scrolledCloseToTop) return;

			if (debug) console.log('Executing: hideHeader');

			$header.addClass(options.classes.headerHidden);
			$body.removeClass(options.classes.stickyHeaderActive);
		};

		var showHeader = function() {
			// if (getViewportWidth() > options.breakpoints.md) {
			$header.removeClass(options.classes.headerHidden);
			$body.addClass(options.classes.stickyHeaderActive);
			// }
		};

		var hideSponsors = function() {
			if (debug) console.log('Attempting: hideSponsors');

			// Exceptions !important
			if (viewportWidth > options.breakpoints.md && cursorAtBottom) return;
			if (scrolledToBottom) return;

			if (debug) console.log('Executing: hideSponsors');

			$sponsors.addClass(options.classes.sponsorsHidden);
		};

		var showSponsors = function() {
			if (viewportWidth > options.breakpoints.md) {
				$sponsors.removeClass(options.classes.sponsorsHidden);
			}
		};

		// Helper for teasing sponsors once in the beginning
		var sponsorLogosIn = function() {
			setTimeout(function() {
				if (!scrolledToBottom) {
					$sponsorLogos.addClass(options.classes.sponsorLogosIn);
					waitingForInitialScroll = true;
				}
			}, 2000);
		};

		var sponsorLogosOut = function() {
			$sponsorLogos.addClass(options.classes.sponsorLogosOut);
			$sponsorLogos.removeClass(options.classes.sponsorLogosIn);
			setTimeout(function() {
				$sponsorLogos.removeClass(options.classes.sponsorLogosOut);
			}, 1000);
		};



		// Helpers for defining scrolling up or down actions
		var animateScrollingUp = function() {
			showHeader();
			showSponsors(); // always show sponsors
		};

		var animateScrollingDown = function() {
			hideHeader();
			showSponsors(); // always show sponsors

			// Failsafe for iOS mobile devices against bouncing off top window edge
			// if (isScrolledToTop) showHeader();
		};



		// Timeout function to be set whenever scrolling or other events stop so
		// the timer can start
		var setTimeoutFnc = function() {
			return setTimeout(function() {
				// if (window.pageYOffset > getHeaderHeight()) {
				hideHeader();
				// }
				// if (!scrolledToBottom) {
				hideSponsors();
				// }
			}, 2000);
		};



		// Helper for setting a class for when window is currently scrolled to
		// page start or not.
		var checkScrolledToTop = function() {
			if (scrolledToTop) {
				$body.removeClass(options.classes.isNotScrolledToTop);
			} else {
				$body.addClass(options.classes.isNotScrolledToTop);
			}
		};




		// -------------------
		// Main Animation Loop
		// -------------------
		var animationLoop = function() {
			// console.log('scrollEvent: ' + scrollEvent);
			// console.log('scrollMouseMove: ' + mouseMoveEvent);

			if (scrollEvent) {
				// reset timer
				clearTimeout(timeoutFncId);
				timeoutFncId = setTimeoutFnc();

				if (waitingForInitialScroll) {
					sponsorLogosOut();
					waitingForInitialScroll = false;
				}

				if (scrollingUp) {
					animateScrollingUp();
				} else if (scrollingDown) {
					animateScrollingDown();
				}

				checkScrolledToTop();

				// reset flas so that we know we handled the event
				scrollEvent = false;
			}

			if (mouseMoveEvent) {
				// (UPDATE): When moving mouse to bottom don't explicitly show sponsors bar. If this behaviour is
				// desired, uncomment the following lines.

				// if (cursorAtBottom) {
				// 	showSponsors();

				// 	// also reset timer here
				// 	clearTimeout(timeoutFncId);
				// 	timeoutFncId = setTimeoutFnc();
				// }

				// reset flas so that we know we handled the event
				mouseMoveEvent = false;
			}

			requestAnimationFrame(animationLoop);
		};


		// -------------------------
		// Initial Queries and Preps
		// -------------------------

		// Initially show header and sponsors, viewports checked inside functions
		showHeader();
		showSponsors();

		// Initially check if page is scrolled to top and set body class accordingly
		checkScrolledToTop();

		// if (getViewportWidth() < options.breakpoints.md) {
		// 	positionHeaderAbsolute();
		// }

		if ($body.hasClass(options.classes.isSchedule)) {
			isSchedulePage = true;
			positionLogoAbsolute();
		}

		if (getViewportWidth() < options.breakpoints.md) {
			sponsorLogosIn();
		}




		// ------------------------
		// Register Event Listeners
		// ------------------------
		$window.on('scroll', function() {
			var currentPageYOffset = window.pageYOffset;

			if (currentPageYOffset + 10 < lastYOffset) {
				if (currentPageYOffset > headerHeight) {
					scrollingUp = true;
					scrollingDown = false;
				}
			} else if (currentPageYOffset - 10 > lastYOffset) {
				scrollingUp = false;
				scrollingDown = true;
			}

			scrolledToTop = isScrolledToTop();
			scrolledCloseToTop = isScrolledCloseToTop();
			scrolledToBottom = isScrolledToBottom();

			lastYOffset = currentPageYOffset;

			// set unhandled scroll event
			scrollEvent = true;
		});

		$window.on('resize', function() {
			viewportWidth = getViewportWidth();
			headerHeight = getHeaderHeight();
		});

		$window.on('mousemove', function(event) {
			clientY = event.clientY;

			cursorAtTop = isCursorAtTop();
			cursorAtBottom = isCursorAtBottom();

			// set unhandled mouse move event
			mouseMoveEvent = true;
		});




		// --------------------
		// Start Animation Loop
		// --------------------
		animationLoop();
	};

	// exports
	return {
		init: init,
	};
}(jQuery));
